import Translator from 'translator';
import { Map } from 'immutable';

import { SvgSDM17DEC, SvgSDM17SPG, SvgUser, SvgTicket } from 'data/common/iconsvg';

export default new Map({
    userList: {
        key: 0,
        label: Translator.translate('general.Users'),
        path: 'user',
        right: 'userList',
        Icon: SvgUser
    },
    smartplugList: {
        key: 2,
        label: Translator.translate('general.SDM17SPG'),
        path: 'SDM17SPG',
        right: 'SDM17SPGList',
        Icon: SvgSDM17SPG
    },
    SDM17DECList: {
        key: 3,
        label: Translator.translate('general.SDM17DEC'),
        path: 'SDM17DEC',
        right: 'SDM17DECList',
        Icon: SvgSDM17DEC
    },
    ticketsgitsList: {
        key: 4,
        label: Translator.translate('general.ticketsgit'),
        path: 'issues',
        right: 'issuesList',
        Icon: SvgTicket
    }
});



// WEBPACK FOOTER //
// ./environments/fhepool/common/subMenuData.js